import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of, shareReplay, tap } from "rxjs";
import { Tour, TourConfig } from "./data";

interface TourSource {
  tours:string;
}

@Injectable()
export class TourService {
  tours:string;
  tours$:Observable<TourConfig[]>;
  tourCache:{[key:string]:Observable<Tour>} = {};

  constructor(private http:HttpClient){

  }

  initialise(source:TourSource ):void {
    this.tours = source.tours;
    if(source.tours){
      this.tours$ = this.http.get<Tour[]>(`${this.tours}?_=${(new Date()).getTime()}`).pipe(shareReplay());
    } else {
      this.tours$ = of([]);
    }

  }

  getTour(tc:TourConfig):Observable<Tour> {
    if(!this.tourCache[tc.title]){
      if(tc.src){
        this.tourCache[tc.title] = this.http.get<Tour>(tc.src).pipe(shareReplay());
      } else {
        this.tourCache[tc.title] = of(tc.tour);
      }
    }
    return this.tourCache[tc.title];
  }
}



